import {
    Button,
    ButtonSize,
    ButtonVariant,
    H6Regular,
    SelectSingle,
    YStack,
} from 'smoothie';

export interface ExistingBeneficiaryOption {
    id: string;
    name: string;
}

interface ChooseBeneficiaryProps {
    existingBeneficiaries: ExistingBeneficiaryOption[];
    onSelectExisting: (id: string) => void;
    onAddNew: () => void;
}

export const ChooseBeneficiary = ({
    existingBeneficiaries,
    onSelectExisting,
    onAddNew,
}: ChooseBeneficiaryProps) => {
    return (
        <YStack gap={24} paddingVertical={24}>
            <H6Regular>
                Would you like to use an existing beneficiary?
            </H6Regular>
            <SelectSingle
                options={existingBeneficiaries
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((b) => ({ title: b.name }))}
                onSelect={(index) => {
                    const selected = existingBeneficiaries[index];
                    if (selected != null) onSelectExisting(selected.id);
                }}
            />
            <Button
                text="Add new beneficiary"
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                onPress={onAddNew}
            />
        </YStack>
    );
};
